export const CBottomFooterCopyright = {
  field: `
      fragment bottomFooterCopyright on bottomFooterCopyright_MatrixField {
        ... on bottomFooterCopyright_copyright_BlockType {
          id
          text
        }
      }
    `,
}
